"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSingleOrder = exports.getOpenOrdersForPlayerAndAsset = exports.getOpenOrdersForPlayerAndCurrency = exports.getOpenOrdersForAsset = exports.getOpenOrdersForCurrency = exports.getOpenOrdersForPlayer = exports.getAllOpenOrders = void 0;
const anchor_1 = require("@project-serum/anchor");
const getMarketplaceProgram_1 = require("./../utils/getMarketplaceProgram");
/**
 * Get an array of all open orders
 * @param connection
 * @param programId - Deployed program ID for GM program
 */
function getAllOpenOrders(connection, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, getMarketplaceProgram_1.getGmIDL)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const filter = [
            {
                dataSize: 201,
            },
        ];
        const orderAccounts = yield program.account.orderAccount.all(filter);
        return orderAccounts;
    });
}
exports.getAllOpenOrders = getAllOpenOrders;
/**
 * Get an array of open orders for a player
 * @param connection
 * @param playerPublicKey - Public key of player
 * @param programId - Deployed program ID for GM program
 */
function getOpenOrdersForPlayer(connection, playerPublicKey, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, getMarketplaceProgram_1.getGmIDL)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const filter = [
            {
                dataSize: 201,
            },
            {
                memcmp: {
                    offset: 8,
                    bytes: playerPublicKey.toBase58(),
                },
            },
        ];
        const orderAccounts = yield program.account.orderAccount.all(filter);
        return orderAccounts;
    });
}
exports.getOpenOrdersForPlayer = getOpenOrdersForPlayer;
/**
 * Get an array of open orders for a given currency
 * @param connection
 * @param currencyMint - Public key of mint
 * @param programId - Deployed program ID for GM program
 */
function getOpenOrdersForCurrency(connection, currencyMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, getMarketplaceProgram_1.getGmIDL)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const filter = [
            {
                dataSize: 201,
            },
            {
                memcmp: {
                    offset: 40,
                    bytes: currencyMint.toBase58(),
                },
            },
        ];
        const orderAccounts = yield program.account.orderAccount.all(filter);
        return orderAccounts;
    });
}
exports.getOpenOrdersForCurrency = getOpenOrdersForCurrency;
/**
 * Get an array of open orders for a given asset
 * @param connection
 * @param assetMint - Public key of mint
 * @param programId - Deployed program ID for GM program
 */
function getOpenOrdersForAsset(connection, assetMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, getMarketplaceProgram_1.getGmIDL)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const filter = [
            {
                dataSize: 201,
            },
            {
                memcmp: {
                    offset: 72,
                    bytes: assetMint.toBase58(),
                },
            },
        ];
        const orderAccounts = yield program.account.orderAccount.all(filter);
        return orderAccounts;
    });
}
exports.getOpenOrdersForAsset = getOpenOrdersForAsset;
/**
 * Get an array of open orders for a given player and currency
 * @param connection
 * @param playerPublicKey - Public key of player
 * @param currencyMint - Public key of mint
 * @param programId - Deployed program ID for GM program
 */
function getOpenOrdersForPlayerAndCurrency(connection, playerPublicKey, currencyMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, getMarketplaceProgram_1.getGmIDL)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const filter = [
            {
                dataSize: 201,
            },
            {
                memcmp: {
                    offset: 40,
                    bytes: currencyMint.toBase58(),
                },
            },
            {
                memcmp: {
                    offset: 8,
                    bytes: playerPublicKey.toBase58(),
                },
            },
        ];
        const orderAccounts = yield program.account.orderAccount.all(filter);
        return orderAccounts;
    });
}
exports.getOpenOrdersForPlayerAndCurrency = getOpenOrdersForPlayerAndCurrency;
/**
 * Get an array of open orders for a given player and asset
 * @param connection
 * @param playerPublicKey - Public key of player
 * @param assetMint - Public key of mint
 * @param programId - Deployed program ID for GM program
 */
function getOpenOrdersForPlayerAndAsset(connection, playerPublicKey, assetMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, getMarketplaceProgram_1.getGmIDL)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const filter = [
            {
                dataSize: 201,
            },
            {
                memcmp: {
                    offset: 72,
                    bytes: assetMint.toBase58(),
                },
            },
            {
                memcmp: {
                    offset: 8,
                    bytes: playerPublicKey.toBase58(),
                },
            },
        ];
        const orderAccounts = yield program.account.orderAccount.all(filter);
        return orderAccounts;
    });
}
exports.getOpenOrdersForPlayerAndAsset = getOpenOrdersForPlayerAndAsset;
/**
 * Takes an order account's public key as a parameter and returns the deserialized contents of the data account.
 * @param connection
 * @param orderAccount - Public key of order account to be deserialized
 * @param programId - Deployed program ID for GM program
 */
function getSingleOrder(connection, orderAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = (0, getMarketplaceProgram_1.getGmIDL)(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const obj = yield program.account.orderAccount.fetch(orderAccount);
        return obj;
    });
}
exports.getSingleOrder = getSingleOrder;
//# sourceMappingURL=order_getters.js.map